import format from 'date-fns/format'
import isToday from 'date-fns/is_today'

export default (date: Date | string, yearType = 'YYYY', dayType = 'Do') => {
  if (isToday(date)) return 'Today'

  return format(date, `${dayType} MMM ${yearType}`)
}
